import { render, staticRenderFns } from "./minimal.vue?vue&type=template&id=7bcc16e0"
import script from "./minimal.vue?vue&type=script&lang=ts"
export * from "./minimal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports